/**
 * useDraftsBadge [2026-05]
 * Laedt die Anzahl offener SAP-Drafts (Status ``draft_pending_sap_verification``)
 * fuer das Sidebar-Badge bei "SAP-Drafts" — als dezenter Impuls, wie viele
 * E-Mail-Drafts noch zu vervollstaendigen sind.
 *
 * Nur fuer User mit ``can_view_complaints``. Auto-Refresh alle 60 Sekunden,
 * damit das Badge live aktuell bleibt (Drafts kommen/gehen via Uebernahme).
 */
import { useState, useEffect, useContext } from 'react';
import { api } from '../lib/axiosClient';
import { AuthContext } from '../contexts/AuthContext';

const REFRESH_INTERVAL_MS = 60_000;

export function useDraftsBadge() {
  const { user } = useContext(AuthContext);
  const [count, setCount] = useState(0);

  const canView = !!user?.permissions?.can_view_complaints;

  useEffect(() => {
    if (!user || !canView) return undefined;

    let alive = true;
    async function load() {
      try {
        const res = await api.get('/complaints/drafts');
        if (!alive) return;
        const c = res?.count ?? (Array.isArray(res?.items) ? res.items.length : 0);
        setCount(Number(c || 0));
      } catch {
        // Silently fail — Badge ist non-critical.
      }
    }
    load();
    const id = setInterval(load, REFRESH_INTERVAL_MS);
    return () => {
      alive = false;
      clearInterval(id);
    };
  }, [user, canView]);

  return { count };
}
